import { Controller, Post, Body, Logger, Get, UseGuards,Req} from '@nestjs/common';
import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler, ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import { ApiTags } from '@nestjs/swagger';
import {ResourceOperationEfficiencyService} from './resource-operation-efficiency.service';
import {resourceOperationEfficiencyDTO} from './dto/resource-operation-efficiency.dto';
import {ResourceOperationEfficiencyResponseModel,AllResourceOperationEfficiencyResponseModel} from '@gtpl/shared-models/planning';
import {ResourceOperationEfficiencyRequest} from './dto/resource-operation-efficiency.request';
import { ResourceOperationEfficiencyAdapter } from './dto/resource-operation-efficiency.adapter';
import { VariantEfficiencyRequest } from './dto/variant-efficiency-request';
@ApiTags('resource-operation-efficiency')
@Controller('resource-operation-efficiency')
export class ResourceOperationEfficiencyController {
  constructor(
    private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    private resourceOperationEfficiencyService: ResourceOperationEfficiencyService

  ){}
  @Post('/createResourceOperationEfficiency')
  async createResourceOperationEfficiency(@Body() resourceOperationEfficiencyDto:resourceOperationEfficiencyDTO[],isUpdate:boolean=false): Promise<ResourceOperationEfficiencyResponseModel> {
  try {
      return await this.resourceOperationEfficiencyService.createResouceOperationEfficiency(resourceOperationEfficiencyDto, false);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(ResourceOperationEfficiencyResponseModel, error);
      // return error;
    }
  }
  @Post('/updateResourceOperationEfficiency')
    async updateResourceOperationEfficiency(@Body() resourceOperationEfficiencyDto: resourceOperationEfficiencyDTO[],@Req() request:Request): Promise<ResourceOperationEfficiencyResponseModel> {
      try {
        console.log('update ResourceOperationEfficiencyResponseModel');
        console.log(request);
        return await this.resourceOperationEfficiencyService.createResouceOperationEfficiency(resourceOperationEfficiencyDto, true);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(ResourceOperationEfficiencyResponseModel, error);
      }
  }
  // @Post('/activateOrDeactivateCountry')
  // async activateOrDeactivateCountry(@Body() countryreq: ResourceOperationEfficiencyRequest): Promise<ResourceOperationEfficiencyResponseModel> {
  //     try {
  //         return await this.resourceOperationEfficiencyService.activateOrDeactivateCountry(countryreq);
  //     } catch (err) {
  //         return this.applicationExceptionHandler.returnException(ResourceOperationEfficiencyResponseModel, err);
  //     }
  // }
  @Post('/getAllResourceOperationEfficiency')
  async getAllResourceOperationEfficiency(@Req() request: Request): Promise<AllResourceOperationEfficiencyResponseModel> {
      try {
          return await this.resourceOperationEfficiencyService.getAllResourceOperationEfficiency();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllResourceOperationEfficiencyResponseModel, error)
      }
  }

  @Post('/getEfficiencyByVariant')
  async getEfficiencyByVariant(@Body() request: VariantEfficiencyRequest): Promise<AllResourceOperationEfficiencyResponseModel> {
      try {
          return await this.resourceOperationEfficiencyService.getEfficiencyByVariant(request);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllResourceOperationEfficiencyResponseModel, error)
      }
  }
}
